import axios from "axios";
import { ElNotification } from "element-plus";
export const nyformService = axios.create({
  baseURL:
    process.env.VUE_APP_ENV == "production"
    // staging api not available
      ? "https://api.vibrant-wellness.com/v1/portal/trans-service/trans"
      : "https://api.vibrant-wellness.com/v1/portal/trans-service-st/trans",
});

let notificationInstance = null;
let notFoundNotificationInstance = null;
let unauthorizedNotification = null;

nyformService.interceptors.request.use(
  function (config) {
    const token = `Bearer ${localStorage.getItem("pnsToken")}`;
    if (token) config.headers["Authorization"] = token;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

nyformService.interceptors.response.use(
  (response) => {
    if (response.status !== 200 && response.status !== 201) {
      console.log('response',response);
      if (!notificationInstance) {
        notificationInstance = ElNotification({
          title: "Failed",
          type: "error",
          customClass: "errorNotification",
          message: response.data.errorMessage,
          duration: 0,
          onClose: () => {
            notificationInstance = null;
          },
        });
      }
      return Promise.reject("error");
    } else {
      return response;
    }
  },
  (error) => {
    const { status } = error.response;
    if (status === 404) {
      if (!notFoundNotificationInstance) {
        notFoundNotificationInstance = ElNotification({
          title: "Failed",
          message: "Not Found",
          customClass: "errorNotification",
          type: "error",
          duration: 3500,
          onClose: () => {
            notFoundNotificationInstance = null;
          },
        });
      }
    } else if (status === 401) {
      if (!unauthorizedNotification) {
        unauthorizedNotification = ElNotification({
          title: "Failed",
          message: "Unauthorized",
          customClass: "errorNotification",
          type: "error",
          duration: 3500,
          onClose: () => {
            unauthorizedNotification = null;
          },
        });
      }
    } else {
      const errorMessage = error.response.data.message.join(", ");
      if (!notificationInstance) {
        notificationInstance = ElNotification({
          title: "Failed",
          message: errorMessage,
          customClass: "errorNotification",
          type: "error",
          duration: 3500,
          onClose: () => {
            notificationInstance = null;
          },
        });
      }
    }
    return Promise.reject(error);
  }
);

export default nyformService;
